// extracted by mini-css-extract-plugin
export var fromLeft = "Inlay-module--fromLeft--1zS0L";
export var fromRight = "Inlay-module--fromRight--cl-qH";
export var image = "Inlay-module--image--L6Ahb";
export var root = "Inlay-module--root--DJMiI";
export var withImage = "Inlay-module--withImage--nouZN";